import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import ComponentDayPicker from '../../../../Components/ComponentDayPicker';
import { getLabelForTimeSlot, filterAllBookingDates, getMonthInfoFromDate, areDatesEquals, getMonthDisabledDays, getNextMonthDaysInfo, getWeekDayTimeSlotDate } from '../../../../Modules/Purchase/BookingSystem';
import T from '../../../../Utils/Locale';
import { AdditionalFields } from '../../SignupForm.constants';
import { getGlobalState } from '../../../../Utils/GlobalState';
import 'react-day-picker/lib/style.css';
const applicationUrl = getGlobalState('application_url');
const BookMeetingSelectTime = ({ purchaseType, partnerId, createdProducts, updateAdditionalData, title }) => {
    const [isLoading, setLoading] = useState(false);
    const [bookingTimeSlots, setBookingTimeSlots] = useState({});
    const [selectedStartTime, setSelectedStartTime] = useState(null);
    const [selectedTimePeriod, setSelectedTimePeriod] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const selectedMonth = selectedTimePeriod == null ? new Date() : new Date(`${selectedTimePeriod.year}/${selectedTimePeriod.month}/${selectedTimePeriod.startDate}`);
    useEffect(() => {
        if (selectedTimePeriod == null) {
            setTimePeriod();
        }
        else {
            fetchTimeSlots();
        }
    }, [selectedTimePeriod]);
    const selectedDayTimeSlots = getSelectedDayTimeSlots();
    return (_jsxs("div", Object.assign({ className: 'booking-main-wrapper' }, { children: [title != null && _jsx("p", Object.assign({ className: 'text-center font-light' }, { children: title })), _jsxs("div", Object.assign({ className: 'wrapper select-date-time-container bg-white p-10 flex flex-col items-center mt-5' }, { children: [_jsx(ComponentDayPicker, { selectedDays: selectedDate, disabledDays: getDisabledDays(), onDayClick: setSelectedDate, onMonthChange: setTimePeriod, month: selectedMonth, fromMonth: new Date(), firstDayOfWeek: 1 }), _jsx("div", Object.assign({ className: 'relative pt-5 pb-5 time-wrapper' }, { children: _jsxs("div", Object.assign({ className: 'time-wrapper-scroll overflow-auto pl-4 pr-4' }, { children: [isLoading && (_jsx("div", Object.assign({ className: 'card-spinner w-full h-full absolute left-0 top-0 bg-white z-20 bg-opacity-75' }, { children: _jsx("div", { className: 'card-spinner--inner' }) }))), !isLoading && (_jsxs(_Fragment, { children: [!isLoading && selectedDayTimeSlots.length === 0 && (_jsx("h4", Object.assign({ className: 'tailwind-reset sub-title text-xs py-3 mb-0' }, { children: T('bookMeeting.selectDateTime.noAvailableTimes') }))), _jsx("div", Object.assign({ className: 'grid grid-flow-row grid-cols-2 grid-rows-2 gap-2 mt-2 md:grid-cols-3 md:grid-rows-3 md:gap-3' }, { children: selectedDayTimeSlots.map((timeSlot) => (_jsx("div", Object.assign({ onClick: handleClickChangeTime(timeSlot) }, { children: _jsx("div", Object.assign({ className: `bg-white rounded shadow cursor-pointer flex items-center justify-center ${areDatesEquals(new Date(timeSlot.start), new Date(selectedStartTime)) ? 'bg-dark-teal text-white' : 'text-gray-47'}` }, { children: _jsx("span", Object.assign({ name: 'timeslot', className: 'flex font-normal cursor-pointer rounded p-2 justify-center items-center w-full h-full' }, { children: getLabelForTimeSlot(timeSlot.start, timeSlot.end) })) })) }), timeSlot.start))) }))] }))] })) }))] }))] })));
    function fetchTimeSlots() {
        const { year, month, startDate, endDate } = selectedTimePeriod;
        if (bookingTimeSlots[`${month}-${year}`] == null) {
            if (!isLoading) {
                setLoading(true);
            }
            axios.get(`${applicationUrl}/api/booking/onboarding/available?purchaseType=${purchaseType}&partner=${partnerId}&productTypes=${createdProducts}&from=${startDate}-${month}-${year}&to=${endDate}-${month}-${year}`, { withCredentials: true })
                .then(({ data }) => {
                setLoading(false);
                if (data.length > 0) {
                    setBookingTimeSlots(Object.assign(Object.assign({}, bookingTimeSlots), { [`${month}-${year}`]: data }));
                    setSelectedDate(getWeekDayTimeSlotDate(data));
                }
                else {
                    if (Object.keys(bookingTimeSlots).length === 0) {
                        setSelectedTimePeriod(getNextMonthDaysInfo(month, year));
                    }
                }
            }).catch(() => setLoading(false));
        }
    }
    function setTimePeriod(date = new Date()) {
        const { month, year, startDate, endDate } = getMonthInfoFromDate(date);
        const bookings = bookingTimeSlots[`${month}-${year}`];
        if (bookings != null) {
            setSelectedDate(getWeekDayTimeSlotDate(bookings));
        }
        setSelectedTimePeriod({ month, year, startDate, endDate });
    }
    function handleClickChangeTime(timeSlot) {
        return () => {
            setSelectedStartTime(timeSlot.start);
            updateAdditionalData({ [AdditionalFields.BOOKING]: timeSlot });
        };
    }
    function getSelectedDayTimeSlots() {
        if (selectedTimePeriod == null) {
            return [];
        }
        const { month, year } = selectedTimePeriod;
        if (bookingTimeSlots[`${month}-${year}`] == null) {
            return [];
        }
        return filterAllBookingDates(Object.values(bookingTimeSlots[`${month}-${year}`]), selectedDate);
    }
    function getDisabledDays() {
        if (selectedTimePeriod == null) {
            return [];
        }
        const { year, month } = selectedTimePeriod;
        const selectedPeriodBookings = bookingTimeSlots[`${month}-${year}`];
        if (selectedPeriodBookings == null) {
            return [];
        }
        return getMonthDisabledDays(selectedPeriodBookings, month, year);
    }
};
BookMeetingSelectTime.propTypes = {
    purchaseType: PropTypes.string.isRequired,
    partnerId: PropTypes.string.isRequired,
    createdProducts: PropTypes.string.isRequired,
    updateAdditionalData: PropTypes.func.isRequired,
    title: PropTypes.string
};
export default BookMeetingSelectTime;
